<!-- 阿里云播放器 -->
<style lang="postcss" scoped>
  /* @import "https://g.alicdn.com/de/prismplayer/2.7.2/skins/default/aliplayer-min.css"; */
  @import 'https://g.alicdn.com/de/prismplayer/2.9.3/skins/default/aliplayer-min.css';
  /deep/ .prism-cover{
    display: none !important;
  }
</style>
<template>
  <div v-if='!isShowTips' class="prism-player" :id="myVideo" style="height:300px;"></div>
  <p v-else style='text-align:center;margin-top:20px;'>当前视频正在转码中，请稍后刷新重试！</p>
</template>
<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'TestTwo',
    props: ['currentVideoUrl','currentVideoId'],
    data() {
      return {
        isShowTips:false,
        myVideo: '',
        playAuth: '',
        videoUrls: '',
        videoId:'',
        aliPlayer: '',
        getVideoUrl: {}
      }
    },
    watch: {
    },
    beforeDestroy() {
      // 销毁播放器实例
      if (this.aliPlayer) {
        this.aliPlayer.dispose()
        this.aliPlayer = null
      }
    },
    mounted() {
      this.videoId = this.currentVideoId ? this.currentVideoId : this.$route.query.videoId;
      this.myVideo = "myvideo" + Date.parse(new Date());
      let _this = this
      document.title = this.$route.meta.title || '视频预览'
      if (this.currentVideoUrl) {
        return
      }
      axios({
        method: 'get',
        timeout: 10000,
        url: `/incontrol-fileserver/vod/getVideoUrl?videoId=${this.videoId}&videoForm=mp4` //测试及生产使用

      }).then(function(response) {
        if (response.data.code == 0) {
          _this.getVideoUrl = response.data

          _this.isShowTips = false
          if(_this.aliPlayer){
            _this.aliPlayer.dispose()
          }
          if (_this.getVideoUrl.data.encryptType == 2 && _this.getVideoUrl.data.playAuthRes) {// ncryptType=2   就是需要使用阿里云视频加密播放的地址
            _this.playAuth = _this.getVideoUrl.data.playAuthRes.playAuth
            _this.videoId = _this.getVideoUrl.data.playAuthRes.videoId
          }else if((_this.getVideoUrl.data.encryptType == 2 && _this.getVideoUrl.data.playList[0].playURL) || (!_this.getVideoUrl.data.encryptType && _this.getVideoUrl.data.playList.length==1 &&(_this.getVideoUrl.data.playList[0].playURL&&_this.getVideoUrl.data.playList[0].playURL.indexOf('https')==-1||!_this.getVideoUrl.data.playList[0].playURL))){
            _this.isShowTips = true
          } else {
            _this.videoUrls = _this.getVideoUrl.data.playList[0].playURL
          }
          console.log(_this.videoUrls, '未加密视频地址')
          console.log(_this.playAuth, '加密视频地址')
          // if(_this.aliPlayer){
          //   _this.aliPlayer.replayByVidAndPlayAuth(_this.videoId, _this.playAuth)
          //   return
          // }
          _this.$nextTick(() => {
            _this.initVideo()
          })
        }
      })
    },
    methods: {
      isWechat() {
        const ua = navigator.userAgent.toLowerCase()
        return ua.indexOf('micromessenger') !== -1
      },
      // 初始化视频方法
      initVideo() {
        let aliConfig = {
          id: this.myVideo,
          width: '100%',
          height: '80%',
          autoplay: true,
          isLive: false,
          rePlay: false,
          playsinline: true,
          preload: true,
          controlBarVisibility: 'hover',
          useH5Prism: true,
          skinLayout: [
            // {name: "bigPlayButton", align: "blabs", x: 30, y: 80},
            {
              name: 'H5Loading',
              align: 'cc',
            },
            { name: 'errorDisplay', align: 'tlabs', x: 0, y: 0 },
            // { name: "infoDisplay" },
            { name: 'tooltip', align: 'blabs', x: 0, y: 56 },
            { name: 'thumbnail' },
            {
              name: 'controlBar',
              align: 'blabs',
              x: 0,
              y: 0,
              children: [
                { name: 'progress', align: 'blabs', x: 0, y: 44 },
                { name: 'playButton', align: 'tl', x: 15, y: 12 },
                { name: 'timeDisplay', align: 'tl', x: 10, y: 7 },
                { name: 'fullScreenButton', align: 'tr', x: 10, y: 12 },
                // { name: "subtitle", align: "tr", x: 15, y: 12 },
                // { name: 'setting', align: 'tr', x: 15, y: 12 }, // 设置
                { name: 'volume', align: 'tr', x: 5, y: 10 },
              ],
            },
          ],
        }
        // 微信端自动播放配置
        if (this.isWechat()) {
          aliConfig['x5-video-player-type'] = 'h5'
          aliConfig['x5-video-player-fullscreen'] = false
          aliConfig['x5-video-orientation'] = 'portraint'
          aliConfig['webkit-playsinline'] = true
          aliConfig.extraInfo = {
            'x5-playsinline': true,
            'x5-video-player-type': 'h5',
            'x5-video-player-fullscreen': false,
          }
          aliConfig.x5_type = 'h5'
          aliConfig.x5_fullscreen = false
          aliConfig.x5_orientation = 0
        }
        if (this.getVideoUrl && this.getVideoUrl.data && this.getVideoUrl.data.encryptType == 2 && this.getVideoUrl.data.playAuthRes) {
          aliConfig.vid = this.videoId
          aliConfig.playauth = this.playAuth
          aliConfig.qualitySort = 'asc'
          aliConfig.format = 'm3u8'
          aliConfig.mediaType = 'video'
          aliConfig.encryptType = '1'
          console.log(aliConfig, '阿里视频配置加密...')
        } else {
          aliConfig.source = this.currentVideoUrl ? this.currentVideoUrl : this.videoUrls
          console.log(aliConfig, '阿里视频配置...')
        }
        this.aliPlayer = new Aliplayer(aliConfig, function (player) {
          console.log('The player is created')
        })
        if (this.isWechat()) {
          // 监听播放器就绪事件
          this.aliPlayer.on('ready', () => {
            setTimeout(() => {
              this.aliPlayer.play().catch(err => {
                console.log('自动播放失败，可能需要用户交互:', err)
              })
            }, 100)
          })
        }
      },
    }
  }
</script>
<style lang='scss' scoped>
</style>